import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import StorePaymentsWrapper from './StorePaymentsWrapper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StorePayoutsPage: React.FC = () => {
  const { store_id } = useParams<{ store_id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

  const stateStoreName = (location.state as { storeName?: string } | null)?.storeName;
  const [apiStoreName, setApiStoreName] = useState<string>('');

  const handleStoreName = useCallback((name: string) => {
    setApiStoreName(name.trim());
  }, []);

  const storeName = (stateStoreName || apiStoreName).trim();

  const handleBack = useCallback(() => {
    if (location.key === 'default') {
      navigate('/admin-dashboard');
    } else {
      navigate(-1);
    }
  }, [navigate, location.key]);

  useEffect(() => {
    setApiStoreName('');
  }, [store_id]);

  return (
    <div className="payouts-page-wrapper">
      <div className="payouts-content">
        <div className="div-block-28">
          <div className="payouts-toolbar">
            {currentRole === 1 ? (
              <span onClick={handleBack} className="payouts-back-btn">
                <ArrowBackIcon />
                <span className="payouts-back-label">
                  {storeName || 'Stores'}
                </span>
              </span>
            ) : null}
          </div>
          
          <div className="payouts-table-wrapper">
            {store_id ? (
              <StorePaymentsWrapper storeId={Number(store_id)} onStoreName={handleStoreName} />
            ) : (
              <p>Invalid store ID.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorePayoutsPage;
